import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSelectionList } from '@angular/material/list';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { ErrorReportService } from 'src/services/error-report.service';
import { HttpService } from 'src/services/http.service';
import { ProcessListService } from 'src/services/process-list.service';
import { CandidateEditDialogComponent } from '../candidate-edit-dialog/candidate-edit-dialog.component';
import { ProcessListInterviewDialogComponent } from '../process-list-interview-dialog/process-list-interview-dialog.component';
import { ProcessListInterviewEvaluatedDialogComponent } from '../process-list-interview-evaluated-dialog/process-list-interview-evaluated-dialog.component';
import { ProcessListSelectionTestDialogComponent } from '../process-list-selection-test-dialog/process-list-selection-test-dialog.component';
import { ProcessListMultipleSelectionTestDialogComponent } from 'src/components/process-list-multiple-selection-test-dialog/process-list-multiple-selection-test-dialog.component';
import { ProcessListCandidatePointsDialogComponent } from '../process-list-candidate-points-dialog/process-list-candidate-points-dialog.component';
import { SelectionTestDialogComponent } from '../selection-test-dialog/selection-test-dialog.component';
import { ProcessListInterviewSessionDialogComponent } from '../process-list-interview-session-dialog/process-list-interview-session-dialog.component';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { map } from 'rxjs/operators';
import { PageEvent } from '@angular/material/paginator';
import { CandidateCommentDialogComponent } from '../candidate-comment-dialog/candidate-comment-dialog.component';
import { RecruiterSearchComponent } from '../recruiter-search/recruiter-search.component';
import { GenericDialogComponent } from '../generic-dialog/generic-dialog.component';

@Component({
  selector: 'app-create-process-list-dialog',
  templateUrl: './create-process-list-dialog.component.html',
  styleUrls: ['./create-process-list-dialog.component.scss']
})
export class CreateProcessListDialogComponent implements OnInit {

  candidateMode: string = 'default';
  public selectionTests: Array<any> = [];
  candidates: Array<any> = [];
  @ViewChild('selectCandidatesForTest', { static: false }) candidatesForTest: MatSelectionList;
  @ViewChild('candidatesForHire', { static: false }) candidatesForHire: MatSelectionList;
  processListId: string = null;
  submiting: boolean = false;
  processListTests: Array<any> = [];
  currentProcessList: any = null;
  processListStatus: string;
  isSmallScreen$: Observable<boolean>;
  formInterview: FormGroup;
  totalLeads: number;
  candidatesCountByProcessListId: { [key: number]: number } = {};
  candidatesCountByProcessListIdNotHired: { [key: number]: number } = {};
  qtdProcessList: number;

  constructor(
    fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) data: any,
    @Inject('MIDIA_ENDPOINT') public mediaEndpoint: string,
    private http: HttpService,
    private errorReport: ErrorReportService,
    private snackbar: MatSnackBar,
    private dialogRef: MatDialogRef<CreateProcessListDialogComponent>,
    private dialog: MatDialog,
    private router: Router,
    private processList: ProcessListService,
    private breakpoint: BreakpointObserver
  ) { 
    if(data) {
      // console.log('Process:', data);
      this.processListId = data.processList.id;
      this.processListStatus = data.processList.status;
      this.currentProcessList = data.processList;
      this.qtdProcessList = data.processList.qtd;
    }

    this.formInterview = fb.group({
      id: [null],
      processList: [this.processListId, Validators.required],
      startAt: [null, Validators.required],
      contact: [null, Validators.required],
      address: [null, Validators.required]
    });

  }

  ngOnInit(): void {

    this.isSmallScreen$ = this.breakpoint
      .observe([Breakpoints.XSmall, Breakpoints.HandsetPortrait])
      .pipe(
        map(state => {
          return state.matches
        })
      )

    this.http.get(`selection_test`)
      .subscribe(
        (result: any) => {
          this.selectionTests = result;
        },
        err => this.errorReport.showMessage(err)
      )

    const subject = new Subject();
    subject.subscribe(
      (result: any) => {

        const { trigger, scope } = result;
        this.submiting = (trigger === 'pre');

      }
    )

    this.http.setLoadingIndicator(subject)
    this.getProcessListLead();
    this.getTotalProcessListLead();
    this.processList.loadCandidates(this.processListId);

  }

  private getTotalProcessListLead() {

    this.http.get('process_list:total_lead', { processList: this.processListId })
      .subscribe(
        (result: any) => this.totalLeads = (result.data.records as number),
        err => this.errorReport.showMessage(err)
      )

  }

  private getProcessListLead(params = null) {

    const data = {
      processList: this.processListId,
      ...params
    };

    this.http.get('process_list:lead', data)
      .subscribe(
        (result: any) => {
          this.candidates = result.data;

          const hiredCandidatesCount = this.candidates.filter(candidate => candidate.candidateStatus === 'hired').length;
          this.candidatesCountByProcessListId[this.processListId] = hiredCandidatesCount;
          const nothiredCandidatesCount = this.candidates.filter(candidate => candidate.candidateStatus !== 'hired').length;
          this.candidatesCountByProcessListIdNotHired[this.processListId] = nothiredCandidatesCount;

        },
        err => this.errorReport.showMessage(err)
      )

  }

  finish() {

    const data = { id: this.processListId };
    this.http.save('process_list:finish', data)
      .subscribe(
        (result: any) => {
          if (result.type === 'OK') {
            this.snackbar.open('Processo concluído com sucesso!', 'OK', { duration: 3000 })
            this.dialogRef.close(true);
          }
        },
        err => this.errorReport.showMessage(err)
      )

  }

  openCandidateComment(lead) {

    const data = {
      candidate: { id: lead.id },
      processList: { id: this.processListId }
    };

    this.dialog.open(CandidateCommentDialogComponent,
      {
        width: '800px',
        disableClose: true,
        data: data
      }
    );

  }

  deleteLead(lead) {
    // if(!confirm(`Deseja realmente remover o candidato ${lead.firstname.toUpperCase()} desse processo seletivo, todos os testes e entrevista relacionados serão removidos também`))
    if (!confirm(`Deseja realmente remover o candidato ${lead.firstname.toUpperCase()} desse processo seletivo`))
      return;

    const data = { processList: this.processListId, lead: lead.id };
    this.http.delete('process_list:lead', data)
      .subscribe(
        (result: any) => {
          if (result.type === 'OK')
            this.getProcessListLead();
        },
        err => this.errorReport.showMessage(err)
      )

  }

  deleteInterview(interview) {

    if (!confirm(`Deseja realmente deletar essa entrevista desse processo seletivo`))
      return;

    const data = { id: interview.id };
    this.http.delete('process_list:interview', data)
      .subscribe(
        (result: any) => {
          if (result.type === 'OK')
            this.getProcessListLead();
        },
        err => this.errorReport.showMessage(err)
      )

  }

  openInterviewEvaluated(candidate) {

    const options = {
      width: '900px',
      disableClose: true,
      data: {
        processList: this.currentProcessList,
        candidate
      }
    }
    this.dialog.open(ProcessListInterviewEvaluatedDialogComponent, options);

  }

  openInterview() {

    const options = {
      width: '900px',
      disableClose: true,
      data: {
        processListId: this.processListId,
        currentProcessList: this.currentProcessList
      }
    }
    this.dialog.open(ProcessListInterviewDialogComponent, options);

  }

  openCandidate(candidate) {

    const options = {
      width: '800px',
      disableClose: true,
      data: {
        candidate,
        processListId: this.processListId,
        readOnly: true
      }
    }
    this.dialog.open(CandidateEditDialogComponent, options);

  }

  addCandidate() {

    this.router.navigate(['/', 'recruiter', 'report'], { queryParams: { id: this.processListId } });
    this.dialogRef.close(true)
    //this.router.navigate(['/', 'recruiter', 'report'], { queryParams: { id: this.processListId }});
    const options = {
      disableClose: true,
      data: {
        processID: this.processListId,
        processStatus: this.processListStatus
      }
    }
    this.dialog.open(RecruiterSearchComponent, options)
      .afterClosed()
      .subscribe(
        () => this.getProcessListLead()
      );

  }

  openSelectionTest(candidate) {

    const options = {
      width: '800px',
      disableClose: true,
      data: {
        processListId: this.processListId,
        candidateId: candidate.id
      }
    }
    this.dialog.open(ProcessListSelectionTestDialogComponent, options)
      .afterClosed()
      .subscribe(
        result => {
          // console.log(result);
        },
        error => {
          console.error(error);
        }
      );

  }

  openQuestionResponses(candidate, showResponses = false) {

    const options = {
      width: '800px',
      disableClose: true,
      data: {
        processListId: this.processListId,
        candidateId: candidate.id,
        showResponses
      }
    }
    this.dialog.open(ProcessListSelectionTestDialogComponent, options);

  }

  openMultipleSelectionTest() {

    const candidatesId = this.candidatesForTest.selectedOptions.selected.map(selected => selected.value);
    const options = {
      disableClose: true,
      width: '800px',
      data: {
        processListId: this.processListId,
        candidatesId,
        processList: this.currentProcessList
      }
    };
    this.dialog.open(ProcessListMultipleSelectionTestDialogComponent, options)
      .afterClosed()
      .subscribe(
        result => {
          if (result)
            this.candidateMode = 'default'
        }
      )

  }

  selectAllCandidates() {

    this.candidatesForTest.selectAll();

  }

  hireCandidates() {

    if (!confirm('Deseja contratar os candidatos selecionados?'))
      return;

    const candidatesId = this.candidatesForHire.selectedOptions.selected.map(selected => selected.value);
    const data = {
      candidates: candidatesId,
      processList: this.processListId
    }

    this.http.save('process_list:hire', data)
      .subscribe(
        (result: any) => {
          if (result.type === 'OK') {
            this.snackbar.open('Candidatos contratado com sucesso!', 'OK', { duration: 3000 });
            this.candidateMode = 'default';
            this.getProcessListLead();
          }
        },
        err => this.errorReport.showMessage(err)
      )

  }

  finishProcess() {

    /*const isHired = this.candidates.some(candidate => candidate.candidateStatus === 'hired');
    if(!isHired) {
      alert('Não é possivel concluir esse processo seletivo, nenhum candidato foi contratado ainda');
      return;
    }*/

    // if(!confirm('Deseja realmente concluir esse processo seletivo?'))
    //   return;
    // const data = {
    //   id: this.processListId
    // }
    // this.http.save('process_list:conclude', data)
    //   .subscribe(
    //     (result: any) => {
    //       if(result.type === 'OK') {
    //         this.dialogRef.close(true);
    //         this.snackbar.open('Processo concluído com sucesso!', 'OK', { duration: 3000 });
    //       }
    //     },
    //     err => this.errorReport.showMessage(err)
    //   )

    let options = {};

    let icon = 'help';
    let icon_class = 'font-icon';
    let message = '';
    let message2 = '';
    let buttons = [];

    const vagasRestantes = this.qtdProcessList - this.candidatesCountByProcessListId[this.processListId];
    message = `Tem certeza que deseja encerrar o processo seletivo?`;

    if (vagasRestantes >= 1) {

      message2 = `ainda há ${vagasRestantes} vaga(s) em aberto.`;
      if (this.candidatesCountByProcessListIdNotHired[this.processListId] >= 1) {
        buttons = [
          { name: 'Encerrar Processo', value: 1, class: 'primary' },
          { name: 'Contratar', value: 2, class: 'success' },
          { name: 'Cancelar', value: false, class: 'danger' }
        ];
      } else {
        buttons = [
          { name: 'Encerrar Processo', value: 1, class: 'primary' },
          { name: 'Cancelar', value: false, class: 'danger' }
        ];
      }

    } else {
      buttons = [
        { name: 'Encerrar Processo', value: 1, class: 'primary' },
        { name: 'Cancelar', value: false, class: 'danger' }
      ];
    }

    options = {
      disableClose: true,
      data: {
        icon,
        icon_class,
        message,
        message2,
        buttons
      }
    };

    this.dialog.open(GenericDialogComponent, options)
      .afterClosed()
      .subscribe(
        result => {
          if (result == 1) {
            // console.log('finish');
            const data = {
              id: this.processListId
            }

            this.http.save('process_list:conclude', data)
              .subscribe(
                (result: any) => {

                  if (result.type === 'OK') {
                    this.snackbar.open('Processo Encerrado com sucesso!', 'OK', { duration: 3000 });
                    window.location.reload();
                  }
                },
                err => this.errorReport.showMessage(err)
              )

          } else if (result == 2) {
            // console.log('contratar');
            this.candidateMode = 'contract';
            return;
          } else {
            return;
          }

        }
      );

  }

  openPoints(lead) {

    const data = {
      candidate: { id: lead.id },
      processList: { id: this.processListId }
    };

    const options = {
      disableClose: true,
      width: '800px',
      data: data
    }
    this.dialog.open(ProcessListCandidatePointsDialogComponent, options);

  }

  close() {
    this.processList.clear(this.processListId);
  }

  openNewTest() {

    const options = {
      disableClose: true,
      width: '800px',
      data: {}
    }
    this.dialog.open(SelectionTestDialogComponent, options)

  }

  openInterviewSession() {

    const options = {
      disableClose: true,
      width: '900px',
      data: {
        processListId: this.processListId
      }
    }
    this.dialog.open(ProcessListInterviewSessionDialogComponent, options)

  }

  pageEvent(args: PageEvent) {

    const { pageIndex, pageSize } = args;
    this.getProcessListLead({ pageIndex, limit: pageSize });

  }

}
